/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenu_viewer = {
    readonly isDeliveryOptionsDisabled: boolean | null;
    readonly isSbSharedRefineMenuDisplayPrefsSelectEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespAppliedFilters_viewer" | "SbSharedRefineMenuFilters_viewer">;
    readonly " $refType": "SbRespRefineMenu_viewer";
};
export type SbRespRefineMenu_viewer$data = SbRespRefineMenu_viewer;
export type SbRespRefineMenu_viewer$key = {
    readonly " $data"?: SbRespRefineMenu_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenu_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenu_viewer",
  "selections": [
    {
      "alias": "isDeliveryOptionsDisabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "DISABLE_SB_DELIVERY_OPTION_FILTERS"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"DISABLE_SB_DELIVERY_OPTION_FILTERS\")"
    },
    {
      "alias": "isSbSharedRefineMenuDisplayPrefsSelectEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespAppliedFilters_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '7d4f97c8e69a8fadb5a785258d2e34cd';
export default node;
